import { registerComponent } from '@gig/magic-common';
import PaginatorComponent from './paginator.vue.js';

var Paginator = registerComponent(PaginatorComponent);

export { Paginator };
